import { ApiError, errorMessage } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * UsageViewModel loads the signed-in tenant's period usage via GET /v1/usage.
 * Closes #438.
 */
export class UsageViewModel extends ViewModel {
    client;
    loadGen = 0;
    constructor(client) {
        super({
            rows: [],
            totalRequests: 0,
            storage: null,
            ledger: null,
            periodStart: null,
            periodEnd: null,
            loading: false,
            error: null,
            unavailable: false,
        });
        this.client = client;
    }
    async load() {
        const gen = ++this.loadGen;
        this.setState({ loading: true, error: null });
        try {
            const summary = await this.client.getUsage();
            if (gen !== this.loadGen)
                return;
            this.setState({
                loading: false,
                unavailable: false,
                totalRequests: summary.totalRequests,
                storage: summary.storage ?? null,
                ledger: summary.ledger ?? null,
                periodStart: summary.periodStart,
                periodEnd: summary.periodEnd,
                rows: summary.byDay.map((d) => ({ date: d.date, requests: d.requests })),
            });
        }
        catch (err) {
            if (gen !== this.loadGen)
                return;
            const rateLimited = err instanceof ApiError && err.code === "rate_limited";
            // Rate limit: keep last good graph; don't flash "rate limit exceeded".
            if (rateLimited) {
                this.setState({ loading: false, error: null });
                if (this.state.rows.length === 0) {
                    await new Promise((r) => setTimeout(r, 1500));
                    if (gen !== this.loadGen)
                        return;
                    try {
                        const summary = await this.client.getUsage();
                        if (gen !== this.loadGen)
                            return;
                        this.setState({
                            loading: false,
                            error: null,
                            unavailable: false,
                            totalRequests: summary.totalRequests,
                            storage: summary.storage ?? null,
                            ledger: summary.ledger ?? null,
                            periodStart: summary.periodStart,
                            periodEnd: summary.periodEnd,
                            rows: summary.byDay.map((d) => ({ date: d.date, requests: d.requests })),
                        });
                    }
                    catch {
                        /* leave zeros + empty bars; no rate_limit banner */
                    }
                }
                return;
            }
            const message = errorMessage(err, "Failed to load usage.");
            this.setState({
                loading: false,
                error: message,
                rows: [],
                totalRequests: 0,
                periodStart: null,
                periodEnd: null,
            });
        }
    }
}
//# sourceMappingURL=UsageViewModel.js.map